import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { formatDate } from "@/lib/format";
import { ShieldAlert } from "lucide-react";

export function BlocchiList({ blocchi }) {
  return (
    <ul className="mt-1.5 space-y-0.5 text-xs" data-testid="blocchi-list">
      {blocchi.map((b, i) => (
        <li key={i}>
          <span className="font-medium">{b.ruolo} {b.riferimento}</span> — {b.tipo} scaduta il {formatDate(b.data_scadenza)}
          {b.codice_viaggio ? <span className="text-red-500"> ({b.codice_viaggio})</span> : null}
        </li>
      ))}
    </ul>
  );
}

export default function BlocchiScadenze({ blocchi, canOverride, motivo, onMotivo }) {
  if (!blocchi?.length) return null;
  return (
    <div className="rounded-md border border-red-300 bg-red-50 p-3 text-red-800" data-testid="blocchi-scadenze-alert">
      <div className="flex items-center gap-2 text-sm font-semibold">
        <ShieldAlert className="h-4 w-4" />Assegnazione bloccata: documenti scaduti alla data del viaggio
      </div>
      <BlocchiList blocchi={blocchi} />
      {canOverride ? (
        <div className="mt-3">
          <Label className="text-xs text-red-900">Forzatura amministrativa — motivazione obbligatoria</Label>
          <Textarea rows={2} className="mt-1 bg-white border-red-300" value={motivo} onChange={(e) => onMotivo(e.target.value)}
            placeholder="Es. rinnovo già effettuato, documento in consegna..." data-testid="override-motivo" />
          <p className="mt-1 text-[11px] text-red-700">La forzatura viene registrata nel log attività con utente, data e motivo.</p>
        </div>
      ) : (
        <p className="mt-2 text-xs">Solo un amministratore può forzare l'assegnazione.</p>
      )}
    </div>
  );
}
